import React, { useState, useEffect, useRef } from 'react';
import styles from './FixedButton.scss';
import ButtonRound, { IButtonProps } from './ButtonRound';

const FixedButton: React.FC<React.PropsWithChildren<IButtonProps & { boundingRef: React.RefObject<HTMLDivElement> }>> = ({
    children = null,
    className,
    boundingRef = null,
    ...props
}) => {
    const posRef = React.useRef<HTMLDivElement>(null);

    const [isVisible, setIsVisible] = React.useState<boolean>(false);
    const [isBoxVisible, setIsBoxVisible] = React.useState<boolean>(true);

    React.useEffect(() => {
        window.addEventListener('scroll', updateVisibility);
        return () => {
            window.removeEventListener('scroll', updateVisibility);
        };
    }, []);

    React.useEffect(() => {
        if (posRef) {
            updateVisibility();
        }
    }, [posRef]);

    const updateVisibility = () => {
        const rect = posRef.current.getBoundingClientRect();

        const containmentRect = {
            bottom: window.innerHeight || document.documentElement.clientHeight,
            left: 0,
            right: window.innerWidth || document.documentElement.clientWidth,
            top: 60,
        };

        const isVisible =
            rect.top + rect.height <= containmentRect.bottom &&
            rect.bottom - rect.height >= containmentRect.top &&
            rect.left <= containmentRect.right &&
            rect.right >= containmentRect.left;

        setIsVisible(isVisible);

        // show sticky button only, if containing box is visible
        let currIsBoxVisible = true;
        if (boundingRef) {
            const boxRect = boundingRef.current.getBoundingClientRect();
            currIsBoxVisible =
                boxRect.top <= containmentRect.bottom &&
                boxRect.bottom >= containmentRect.top &&
                boxRect.left <= containmentRect.right &&
                boxRect.right >= containmentRect.left;
        }
        setIsBoxVisible(currIsBoxVisible);
    };

    return (
        <div className={styles.fixedButton}>
            <div ref={posRef} className={isVisible ? null : styles.relative}></div>
            <div className={isVisible || !isBoxVisible ? null : styles.fixed}>
                <ButtonRound className={className} {...props}>
                    {children}
                </ButtonRound>
            </div>
        </div>
    );
};

export default FixedButton;
